class BetQueue {

    static init() {
        this.items = {};
        this.frontIndex = 0;
        this.backIndex = 0;
    }

    static enqueue(item) {
        this.items[this.backIndex] = item;
        this.backIndex++;
    }

    static dequeue() {
        const item = this.items[this.frontIndex];
        delete this.items[this.frontIndex];
        this.frontIndex++;
        return item;
    }

    static peek() {
        return this.items[this.frontIndex];
    }

    static getQueue() {
        var arrayToReturn = [];

        for (var i = this.backIndex; i > this.frontIndex; i--) {
            arrayToReturn.push(this.items[i - 1]);

            if (arrayToReturn.length === 20) { //just return last 20
                break;
            }
        }

        return arrayToReturn;
        //return this.items;
    }
}

export default BetQueue;